import Api from '../utils/api';
import { APP_INITIALIZED } from 'utils/constants';

export const initializeApp = () => (dispatch, getState) => {
  dispatch({
    type: APP_INITIALIZED,
    data: { api: new Api()}
  })
};



// WEBPACK FOOTER //
// ./src/actions/initializeApp.js